export const commonInnerClasses =
  'focus-within:caret-indigo-600 focus-within:border-b-2 focus-within:border-b-indigo-600 focus-within:border-opacity-100';
